// Read independently of the table so pagination does not hide map devices or
// replace the user's current table page.
export async function loadMapDevices(getPage, filters) {
    const rows = []
    let count = Infinity
    while (rows.length < count) {
        const page = await getPage({...filters, limit: 250, offset: rows.length, sortColumn: 'id', sort: 'asc'})
        if (!Array.isArray(page.rows)) throw new Error('Invalid device list response')
        if (!page.rows.length) break
        rows.push(...page.rows)
        if (Number.isFinite(Number(page.count))) count = Number(page.count)
    }
    return rows
}

export function mergeMapDevices(markers, devices) {
    const statuses = new Map(markers.list.map(marker => [String(marker.id), marker]))
    return {
        ...markers,
        list: devices.map(device => {
            const status = statuses.get(String(device.id))
            // The ordinary list is authoritative for membership and coordinates;
            // the marker response supplies live status and alert information.
            return {
                ...device,
                ...(status || {}),
                id: device.id,
                lat: device.lat,
                lon: device.lon,
                location: device.location,
                title: device.title,
                serial_number: device.serial_number
            }
        })
    }
}
